import React from "react"
import PropTypes from "prop-types"

import PricingChoice from './PricingChoice'
import LexicoinItem from './LexicoinItem'
import IdChoice from './IdChoice'

class OneTimeChoice  extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      pro: '',
      id_verification: ''
    }

    this.idVerificationLink = this.idVerificationLink.bind(this)
    this.selectItem = this.selectItem.bind(this)
    this.hasIdVerification = this.hasIdVerification.bind(this)
    this.isPro = this.isPro.bind(this)
  }

  isPro() {
    if(this.props.current_user === null) {
      return false
    } else if((this.props.subscription != null && this.props.subscription.plan_id != null) || this.props.current_user.premium === true || this.props.current_user.basic_forever === true) {
      return true
    } else {
      return false
    }
  }

  hasIdVerification() {
    if(this.props.id_verification === null || this.props.id_verification === undefined) {
      return false
    } else  {
      return true
    }
  }

  idVerificationLink() {
    if(this.hasIdVerification()) {
      if(this.props.id_verification.is_verified === true) {
        window.location.assign("/verify_identity_status")
      }
      window.location.assign("/verify_identity_steps")
    }
    this.selectItem(1)
  }

  selectItem(item_id) {
    this.props.openCheckout(item_id)
  }

  render() {
    if (this.props.tab === 3) {
      return(
        <div style={{maxWidth: 1000, margin: 'auto'}}>
          <IdChoice size="small" selected={this.hasIdVerification()}  buttonText={this.hasIdVerification() ? "INFO" : "CHOOSE"} onClick={this.idVerificationLink}>
              <h3 className="pricing-card-title">VERIFY IDENTITY</h3>
              <h1 className="pricing-number">$10</h1>
              <h5 className="pricing-duration">one time</h5>
              <hr className="pink-section-break"></hr>
              <h5 className="pricing-description-text-h5">Verify your online identity</h5>
              <h5 className="pricing-description-text-h5">Verified badge on your profile</h5>
              <h5 className="pricing-description-text-h5">Only be contacted by<br />other verified members</h5>
          </IdChoice>
        </div>
      )
    }
    return(
      <div style={{maxWidth: 350, margin: 'auto', display: 'flex', justifyContent: 'space-between'}}>
          <LexicoinItem
            size="small"
            onClick={() => this.selectItem(2)}
            title="1 Lexicoin"
            imageName="oneLexicoin"
            price="$1">
          </LexicoinItem>
          <LexicoinItem
            size="small"
            onClick={() => this.selectItem(3)}
            title="10 Lexicoins"
            imageName="tenLexicoins"
            price="$8">
          </LexicoinItem>
      </div>
    )
  }
}

export default OneTimeChoice
// {this.isPro() === false && <PricingChoice size="small" onClick={() => window.location.assign("/get_chat_credits?item_id=4")} buttonText="CHOOSE">
//     <h3 className="pricing-card-title">25 GOLD CHAT CREDITS</h3>
//     <h1 className="pricing-number">$20</h1>
//     <h5 className="pricing-duration">one time</h5>
//     <hr className="pink-section-break"></hr>
//     <div className="coin-image-container">
//       <img src={this.props.twenty_five_credit_img_src} className="coin-image" />
//     </div>
//     <h5 className="pricing-description-text-h5">Chat credits that never expires</h5>
// </PricingChoice>}
// {this.isPro() === false && <PricingChoice size="small" onClick={() => window.location.assign("/get_chat_credits?item_id=5")} buttonText="CHOOSE">
//     <h3 className="pricing-card-title">50 GOLD CHAT CREDITS</h3>
//     <h1 className="pricing-number">$39</h1>
//     <h5 className="pricing-duration">one time</h5>
//     <hr className="pink-section-break"></hr>
//     <div className="coin-image-container">
//       <img src={this.props.fifty_credit_img_src} className="coin-image" />
//     </div>
//     <h5 className="pricing-description-text-h5">Chat credits that never expires</h5>
// </PricingChoice>}
// {this.isPro() === false && <PricingChoice size="small" onClick={() => window.location.assign("/get_chat_credits?item_id=6")} buttonText="CHOOSE">
//     <h3 className="pricing-card-title">100 GOLD CHAT CREDITS</h3>
//     <h1 className="pricing-number">$75</h1>
//     <h5 className="pricing-duration">one time</h5>
//     <hr className="pink-section-break"></hr>
//     <div className="coin-image-container">
//       <img src={this.props.one_hundred_credit_img_src} className="coin-image" />
//     </div>
//     <h5 className="pricing-description-text-h5">Chat credits that never expires</h5>
// </PricingChoice>}
